import { KeyRound } from "lucide-react";
import { RolesCard } from "@/components/RolesCard";
import { TeamAccessCard } from "@/components/TeamAccessCard";

export default function Access() {
  return (
    <div className="space-y-6 animate-fade-up max-w-5xl" data-testid="access-page">
      <div><h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2"><KeyRound className="w-7 h-7 text-primary" /> Roles & Access</h1><p className="text-sm text-muted-foreground mt-1">Give coworkers their own login with access to only the modules they need — e.g. a Schedule Manager who never sees payroll.</p></div>
      <TeamAccessCard />
      <RolesCard />
    </div>
  );
}
